import { legalTr } from './legal-tr.ts';
import { legalEn } from './legal-en.ts';
import { lang } from './index.ts';

// Yasal metinlerin veri biçimi. İki dil aynı yapıyı taşır; görünüm (legal.ts)
// yalnızca bu yapıyı çizer. `{brand}` yer tutucusu marka adıyla doldurulur.

export type LegalTab = 'terms' | 'privacy' | 'cookies' | 'kvkk' | 'subscription' | 'safety' | 'copyright' | 'contact';

export type LegalParagraph = string | { list: string[] } | { contact: string };

export interface LegalBlock {
  title: string;
  body: LegalParagraph[];
}

export interface LegalSection {
  key: LegalTab;
  label: string;
  blocks: LegalBlock[];
}

export interface LegalContent {
  title: string;
  updated: string;
  note: string;
  sections: LegalSection[];
}

export const LEGAL_TABS: LegalTab[] = ['terms', 'privacy', 'cookies', 'kvkk', 'subscription', 'safety', 'copyright', 'contact'];

export function legalContent(): LegalContent {
  return lang() === 'en' ? legalEn : legalTr;
}

export function legalLabel(key: LegalTab): string {
  return legalContent().sections.find((s) => s.key === key)?.label ?? key;
}
